import { render } from "./ConfirmationText.vue?vue&type=template&id=70b65606"
import script from "./ConfirmationText.vue?vue&type=script&lang=js"
export * from "./ConfirmationText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__